import { server } from "@/api";

const prefix = 'api/videos';
const adminPrefix = 'api/admin/videos';

// ─── Public / viewer facing ───────────────────────────────────────────────
export const paginate = async (params = {}) => {
    return await server().get(prefix, { params });
};

export const get = async (id, params = {}) => {
    return await server().get(`${prefix}/${id}`, { params });
};

// ─── Admin management ──────────────────────────────────────────────────────
export const admin = {
    paginate: async (params = {}) => {
        return await server().get(adminPrefix, { params });
    },
    get: async (id, params = {}) => {
        return await server().get(`${adminPrefix}/${id}`, { params });
    },
    edit: async (id, params = {}) => {
        return await server().get(`${adminPrefix}/${id}/edit`, { params });
    },
    store: async (data) => {
        return await server().post(adminPrefix, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    update: async (id, data) => {
        return await server().post(`${adminPrefix}/${id}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    toggleStatus: async (id) => {
        return await server().put(`${adminPrefix}/${id}/toggle-status`);
    },
    destroy: async (id) => {
        return await server().delete(`${adminPrefix}/${id}`);
    }
};

const videosApi = {
    paginate,
    get,
    admin
};

export default videosApi;
